import { useEffect } from "react";
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorAppUserNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IAppUserModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IAppUserFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useAppUserHookNae(id: number) : IAppUserModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorAppUserNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: "app-user",
        fields: IAppUserFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
